import { EditorView } from 'prosemirror-view';
import { EditorState, TextSelection } from 'prosemirror-state';
import { Node as ProsemirrorNode, Mark, MarkType } from 'prosemirror-model';

export function currentMark(
  doc,
  endPos,
  type
) {
  let $endPos = doc.resolve(Math.max(0, endPos));
  let start = $endPos.parent.childAfter($endPos.parentOffset);

  if (!start.node) {
    return;
  }

  return start.node.marks.find((mark) => mark.type === type);
}

//
// Adapted from
//   https://discuss.prosemirror.net/t/expanding-the-selection-to-the-active-mark/478/4
//
export function currentMarkRange(
  doc,
  pos,
  state,
  type
) {
  const $pos = doc.resolve(pos);
  const start = $pos.parent.childAfter($pos.parentOffset);

  if (!start.node) {
    return;
  }

  const mark = start.node.marks.find((mark) => mark.type === type);

  if (!mark) {
    return;
  }

  let startIndex = $pos.index();
  let startPos = $pos.start() + start.offset;
  while (startIndex > 0 && mark.isInSet($pos.parent.child(startIndex - 1).marks)) {
    startIndex -= 1;
    startPos -= $pos.parent.child(startIndex).nodeSize;
  }

  let endIndex = $pos.indexAfter();
  let endPos = startPos + start.node.nodeSize;
  while (endIndex < $pos.parent.childCount && mark.isInSet($pos.parent.child(endIndex).marks)) {
    endPos += $pos.parent.child(endIndex).nodeSize;
    endIndex += 1;
  }

  return { from: startPos, to: endPos };
}

export function selectMarkAtCursor(editorView, markType) {
  const doc = editorView.state.selection.$to.doc;
  const range = currentMarkRange(doc, editorView.state.selection.to, editorView.state, markType);
  if (range) {
    const { from, to } = range;
    const selection = TextSelection.create(doc, from, to);
    editorView.dispatch(editorView.state.tr.setSelection(selection));
  }
}

export function getMarkAtCursor(editorView, markType) {
  return currentMark(editorView.state.selection.$to.doc, editorView.state.selection.to, markType);
}

//
// Like rangeHasMark() except the range must be within,
//   or perfectlying containing the target mark type
// https://github.com/ProseMirror/prosemirror-model/blob/6d970507cd0da48653d3b72f2731a71a144a364b/src/node.js#L228
//
export function rangeIsMark(doc, from, to, type) {
  // Normalize selection for both directions so we can +1 the start for more inclusion
  const start = from <= to ? from : to;
  const end = from <= to ? to : from;

  const startMarks = doc
    .resolve(start + 1)
    .marks()
    .filter(mark => mark.type === type);

  if (startMarks.length === 0) {
    return false;
  }

  return (
    doc
      .resolve(end)
      .marks()
      .filter(mark => mark.type === type && startMarks.includes(mark)).length === 1
  );
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/selection.js